// ABOUTME: Header v2 client-side behavior — inline menu hover, mega menu Custom Elements, mobile drawer accordion, sticky header.
// ABOUTME: Loaded once via section template; each Custom Element guards its own definition with customElements.get.

(function () {
  const inlineMenu = document.querySelector('.hv2-header__inline-menu');
  if (!inlineMenu) return;

  const entries = [];

  inlineMenu.querySelectorAll(':scope > ul > li').forEach((li) => {
    const details = li.querySelector(':scope > header-menu > details, :scope > details');
    if (!details) return;
    entries.push({ li, details, closeTimer: null });
  });

  const closeOthers = (current) => {
    entries.forEach((entry) => {
      if (entry === current) return;
      clearTimeout(entry.closeTimer);
      entry.closeTimer = null;
      if (entry.details.hasAttribute('open')) entry.details.removeAttribute('open');
    });
  };

  entries.forEach((entry) => {
    const { li, details } = entry;

    const open = () => {
      clearTimeout(entry.closeTimer);
      entry.closeTimer = null;
      closeOthers(entry);
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    };

    const scheduleClose = () => {
      clearTimeout(entry.closeTimer);
      entry.closeTimer = setTimeout(() => {
        if (details.hasAttribute('open')) details.removeAttribute('open');
      }, 80);
    };

    li.addEventListener('pointerenter', open);
    li.addEventListener('pointerleave', scheduleClose);
    li.addEventListener('focusin', open);
    li.addEventListener('focusout', (event) => {
      if (!li.contains(event.relatedTarget)) scheduleClose();
    });
  });
})();

if (!customElements.get('bestseller-mega-menu')) {
  class BestsellerMegaMenu extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.hv2-mega-menu__category'));
      this.panes = Array.from(this.querySelectorAll('.hv2-mega-menu__pane'));

      if (!this.tabs.length || !this.panes.length) return;

      this.activate(this.getAttribute('data-default-index') || 0);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.index));
        tab.addEventListener('pointerenter', () => this.activate(tab.dataset.index));
        tab.addEventListener('focus', () => this.activate(tab.dataset.index));
      });
    }

    activate(index) {
      const target = String(index);
      this.tabs.forEach((tab) => {
        const active = tab.dataset.index === target;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panes.forEach((pane) => {
        const active = pane.dataset.index === target;
        pane.classList.toggle('is-active', active);
        if (active) {
          pane.removeAttribute('hidden');
        } else {
          pane.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('bestseller-mega-menu', BestsellerMegaMenu);
}

if (!customElements.get('mobile-nav-accordion')) {
  class MobileNavAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      const summary = this.details && this.details.querySelector('summary');
      this.submenu = this.querySelector('.hv2-mobile-nav__submenu');
      if (!this.details || !summary || !this.submenu) return;

      // Neutralise Dawn's MenuDrawer listener (bound to all summaries inside header-drawer).
      // Cloning the node drops all previously-attached listeners.
      const fresh = summary.cloneNode(true);
      summary.replaceWith(fresh);
      this.summary = fresh;
      this.summary.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();
      // Stop Dawn from re-attaching its handler after our clone trick in edge cases.
      event.stopImmediatePropagation();
      if (this.details.open) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    closeSiblings() {
      const root = this.closest('.hv2-menu-drawer') || document;
      root.querySelectorAll('mobile-nav-accordion').forEach((acc) => {
        if (acc !== this && acc.details && acc.details.open) acc.collapse();
      });
    }

    expand() {
      this.closeSiblings();
      this.details.open = true;
      this.summary.setAttribute('aria-expanded', 'true');
      this.submenu.style.height = '0px';
      requestAnimationFrame(() => {
        this.submenu.style.height = this.submenu.scrollHeight + 'px';
      });
      const onEnd = () => {
        this.submenu.style.height = '';
        this.submenu.removeEventListener('transitionend', onEnd);
      };
      this.submenu.addEventListener('transitionend', onEnd);
    }

    collapse() {
      this.summary.setAttribute('aria-expanded', 'false');
      this.submenu.style.height = this.submenu.scrollHeight + 'px';
      requestAnimationFrame(() => {
        this.submenu.style.height = '0px';
      });
      const onEnd = () => {
        this.details.open = false;
        this.submenu.style.height = '';
        this.submenu.removeEventListener('transitionend', onEnd);
      };
      this.submenu.addEventListener('transitionend', onEnd);
    }
  }

  customElements.define('mobile-nav-accordion', MobileNavAccordion);
}

(function () {
  const announcementBar = document.querySelector('.announcement-bar-section');
  if (!announcementBar) {
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    return;
  }
  const update = () => {
    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
  };
  update();
  window.addEventListener('resize', update);
  if ('ResizeObserver' in window) {
    new ResizeObserver(update).observe(announcementBar);
  }
})();

if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.hv2-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
}
